export default __webpack_public_path__ + "static/media/middle.5bcb5a38.jpg";